import { Injectable } from '@angular/core';
import { ToastService } from './toast.abstract.service';
import { notify } from '@radancy-pe/ui-elements';

@Injectable()
export class ToastStandaloneService extends ToastService {
  protected displayError(message: string): void {
    notify({ message, variant: 'error' });
  }

  protected displaySuccess(message: string): void {
    notify({ message, variant: 'success' });
  }
}
